import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GxIconComponent } from './gx-icon.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    GxIconComponent
  ],
  declarations: [
    GxIconComponent
  ]
})
export class GxIconModule { }
